import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";

Chart.register(ArcElement, Tooltip, Legend); // Register required elements
const URL = process.env.REACT_APP_API_URL;
const CandidateBySource = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${URL}/api/candidates-source`);
        const data = await response.json();

        if (!data || Object.keys(data[0]).length === 0) {
          setError("No valid data received from API");
          setLoading(false);
          return;
        }

        const labels = Object.keys(data[0]);
        const values = Object.values(data[0]);

        setChartData({
          labels,
          datasets: [
            {
              label: "Candidates by Source",
              data: values,
              backgroundColor: [
                "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40"
              ],
              hoverOffset: 10, // Enhancing hover effect
            },
          ],
        });

        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load data");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom", // Moves legend below the chart
        labels: {
          font: { size: 14 }, // Increases font size
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `${tooltipItem.label}: ${tooltipItem.raw} candidates`,
        },
      },
    },
  };

  return (
    <div style={{
      width: "70%",
      margin: "auto",
      padding: "20px",
      textAlign: "center"
    }}>
      <h2 style={{
        fontFamily: "Arial, sans-serif",
        fontSize: "20px",
        fontWeight: "bold",
        marginTop: "-10px", // ✅ Moves heading slightly up without affecting other content
        marginBottom: "30px", // ✅ Maintains good spacing between heading & chart
      }}>
        Candidates by Source
      </h2>

      {loading ? (
        <p>Loading data...</p>
      ) : error ? (
        <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>
      ) : (
        <div style={{
          height: "400px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden" // ✅ Prevents pie chart from overflowing outside its container
        }}>
          <Pie data={chartData} options={chartOptions} />
        </div>
      )}
    </div>
  );
};

export default CandidateBySource;